import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useCart } from "../cart";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Products = () => {
  const { add } = useCart();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((r) => setProducts(r.data))
      .catch((err) => {
        if (process.env.NODE_ENV !== "production") {
          console.error(err);
        }
      });
  }, []);

  return (
    <section
      id="products"
      className="relative pt-8 md:pt-16 pb-32 md:pb-44 satin-bg overflow-hidden"
      data-testid="products-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {products.map((p, idx) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (idx % 3) * 0.1 }}
              className="card-luxe flex flex-col"
              data-testid={`product-card-${p.id}`}
            >
              {/* Product image */}
              <div className="relative aspect-[4/5] overflow-hidden bg-[#F4ECDD] group">
                <img
                  src={p.image}
                  alt={p.name}
                  className={`w-full h-full object-cover transition-all duration-700 ease-out group-hover:scale-105 ${p.image_hover ? "group-hover:opacity-0" : ""}`}
                />
                {p.image_hover && (
                  <img
                    src={p.image_hover}
                    alt={p.name}
                    className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-out"
                    aria-hidden="true"
                  />
                )}
              </div>

              {/* Card body */}
              <div className="flex-1 flex flex-col px-6 py-7 md:px-8 md:py-8 text-center">
                <h3
                  className="font-serif text-2xl md:text-3xl uppercase tracking-wider text-[#1A1612] mb-2"
                  data-testid={`product-name-${p.id}`}
                >
                  {p.name}
                </h3>
                {p.variety && (
                  <p className="font-serif italic text-base text-[#B8954C] mb-4">{p.variety}</p>
                )}
                <div className="sep-line mb-4">
                  <span className="diamond" />
                </div>
                <p className="text-sm md:text-base text-[#6E665A] font-light leading-relaxed mb-6 min-h-[3rem]">
                  {p.tagline || p.description}
                </p>
                <div className="font-serif text-2xl text-[#1A1612] mb-6" data-testid={`product-price-${p.id}`}>
                  {Number(p.price).toFixed(0)} <span className="text-[#B8954C] text-base tracking-widest">RON</span>
                </div>
                <button
                  onClick={() => add(p)}
                  className="btn-pill w-full mt-auto"
                  data-testid={`add-to-cart-${p.id}`}
                >
                  Adaugă în coș
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
